




































import { Component, Vue } from 'vue-property-decorator'; // @ is an alias to /src
import axios from 'axios';

@Component({
  components: {
    
  },
})
export default class Update extends Vue {
  file = "";
  updateCode: string = '';
  errorOccured = false;
  errorMessage = '';
  
    async onSubmit() {
        let data = new FormData();
        if (this.file === "")
          return;
        
        data.append('file', this.file);
        data.append('updateCode', this.updateCode);
        await axios.post('api/reader/UpdateData', data, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(result => {
          if (result.data.status === 'success') {
            this.errorOccured = false;
            this.$router.push({ name: 'home' });              
          } else {
            this.errorMessage = result.data.message;
            this.errorOccured = true;
          }
        })
    //await this.$router.push({ name: 'home' });
  }
  
}
